export default "__VITE_ASSET__966b3b89__"